import Select from 'components/Select';
import {components, CSSObjectWithLabel} from 'react-select';
import styles from '../WorkerSelect.module.scss';
import {get} from 'lodash';
import Typography from 'components/Typography';
import classNames from 'classnames';
import IconUser from 'pages/DeliveryPlanner/icons/user';
import {Link} from 'react-router-dom';

type IndividualProps = {
  options: {
    label: string;
    value: string | number;
    [key: string]: any;
  };
  value?: any;
  onChange: (val: any) => void;
  selectedId?: number | string;
  color?: string;
};

const control = (base: CSSObjectWithLabel): CSSObjectWithLabel => ({
  ...base,
  minWidth: 192,
  fontSize: '14px !important',
  borderRadius: '6px !important',
});
const Individual = ({
  options,
  value,
  selectedId,
  onChange,
}: IndividualProps) => {
  return (
    <div className={styles.flex}>
      <div className={styles.individualIcon}>
        <IconUser width={20} height={20} />
      </div>

      <Select
        value={value}
        options={options as any}
        onChange={onChange}
        styles={{control}}
        menuPosition="fixed"
        isSearchable={false}
        components={{
          NoOptionsMessage: (props) => {
            return (
              <components.NoOptionsMessage {...props}>
                <Link
                  className={styles.addNewWorkerLink}
                  to="/people/employees/new"
                >
                  <span>+ Add new worker</span>
                </Link>
              </components.NoOptionsMessage>
            );
          },
          Option: (props) => {
            return (
              <components.Option {...props}>
                <div className={styles.teamItemHeader}>
                  <div className={styles.teamItemHeaderText}>
                    <Typography
                      className={classNames(
                        styles.teamItemHeaderTextName,
                        selectedId === props.data.value && styles.activeTeam
                      )}
                    >
                      {get(props.data, 'first_name', '') +
                        ' ' +
                        get(props.data, 'last_name', '')}
                    </Typography>
                  </div>
                </div>
              </components.Option>
            );
          },
        }}
        placeholder="Select Worker"
      />
    </div>
  );
};

export default Individual;
